function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10",
  height: "10",
  viewBox: "-5 -5 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.667 13.667a.96.96 0 01-.7-.3.96.96 0 01-.3-.7V1.333c0-.266.1-.5.3-.7.2-.2.433-.3.7-.3h5.6c.133 0 .266.034.4.067C7.8.433 7.9.533 8 .633l3.033 3.034c.1.1.167.2.234.333.066.133.066.267.066.4v8.267c0 .266-.1.5-.3.7-.2.2-.433.3-.7.3H1.667z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.167 9.875a.473.473 0 01-.125-.333c0-.125.041-.25.125-.334l1.25-1.25H2.458a.473.473 0 01-.333-.125A.473.473 0 012 7.5c0-.125.042-.25.125-.333a.473.473 0 01.333-.125h4.917l-1.25-1.25A.473.473 0 016 5.458c0-.125.042-.25.125-.333A.473.473 0 016.458 5c.125 0 .25.042.334.125l2.041 2.042a.575.575 0 01.125.166c0 .042.042.125.042.167 0 .042 0 .125-.042.167 0 .041-.041.083-.125.166L6.792 9.875a.473.473 0 01-.334.125c-.083 0-.166-.042-.291-.125z",
  fill: "#333"
})));